var render = function render(){var _vm=this,_c=_vm._self._c;return _c('el-tooltip',_vm._b({attrs:{"value":_vm.value,"visible-arrow":_vm.isArrowVisible,"manual":_vm.isManual,"enterable":_vm.isMouseEnterable,"effect":_vm.tooltipTheme}},'el-tooltip',_vm.trimAttrs(_vm.$attrs),false),[_c('template',{slot:"content"},[_vm._t("content")],2),_vm._t("default")],2)
}
var staticRenderFns = []

export { render, staticRenderFns }